import { lazy } from 'react';

// Lazy load containers for better code splitting
export const LazyHeader = lazy(() => import('../container/Header/Header'));
export const LazyAbout = lazy(() => import('../container/About/About'));
export const LazyWork = lazy(() => import('../container/Work/Work'));
export const LazySkills = lazy(() => import('../container/Skills/Skills'));
export const LazyTestimonial = lazy(() => import('../container/Testimonial/Testimonial'));
export const LazySystems = lazy(() => import('../container/Systems/Systems'));
export const LazyFooter = lazy(() => import('../container/Footer/Footer'));
export const LazyFloatingBubbles = lazy(() => import('../components/FloatingBubbles/FloatingBubbles'));
